import { TranslatePipe } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {
    TrainingPlanning,
    TrainingPlanningService,
} from '../../../../_services';
import { Principal } from '../../../../shared/auth/principal.service';

@Component({
    selector: 'training-detail-planning',
    templateUrl: 'planning.component.html',
    styleUrls: ['planning.component.scss'],
    providers: [TranslatePipe],
})
export class TrainingDetailPlanningComponent implements OnInit {
    @Input() training;
    plannedSessions: TrainingPlanning[];
    deletingTrainingPlanning: TrainingPlanning;
    deleteModalRef: any;
    success: boolean = false;
    private account: any;

    constructor(
        private trainingPlanningService: TrainingPlanningService,
        private modalService: NgbModal,
        private principal: Principal
    ) {}

    ngOnInit() {
        this.fetch();
        this.initAccount();
    }

    initAccount() {
        this.principal.identity().then((account) => {
            this.account = account;
        });
    }

    fetch() {
        this.trainingPlanningService
            .findAllByTrainingId(this.training.id)
            .subscribe(
                (plannedSessions) => (this.plannedSessions = plannedSessions)
            );
    }

    showModal(deleteModal, deletingTrainingPlanning) {
        event.stopPropagation();
        this.deletingTrainingPlanning = deletingTrainingPlanning;
        this.deleteModalRef = this.modalService.open(deleteModal);
    }

    closeModal() {
        this.deleteModalRef.close();
    }

    saved() {
        this.fetch();
        this.success = true;
        setTimeout((_) => {
            this.success = false;
        }, 5 * 1000);
    }

    remove() {
        this.closeModal();
        this.trainingPlanningService
            .remove(
                this.deletingTrainingPlanning.trainingId,
                this.deletingTrainingPlanning.id,
                () => {
                    this.fetch();
                }
            )
            .subscribe();
    }

    currentUserHasNotRoles(roles: string[]): boolean {
        let res = true;
        this.account.authorities.forEach((role) => {
            if (roles.indexOf(role) !== -1) {
                res = false;
            }
        });
        return res;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/training/detail/planning/planning.component.ts